<div class="wrapper">
  <tui-island>
    <div class="text-center margin-bottom-lg">
      <img src="assets/images/ionity_logo_light.jpg" alt="Ionity Logo" />
    </div>

    <div class="margin-bottom-xs">
      <button ionButton appearance="cta" (click)="signIn()" ion-id="sign-in-ionity">
        {{ "SIGN_IN.SIGN_IN_IONITY" | translate }}
      </button>
    </div>

    <div>
      <button ionButton appearance="primary" [routerLink]="'/email-sign-in'" ion-id="sign-in-fleet">
        {{ "SIGN_IN.SIGN_IN_FLEET" | translate }}
      </button>
    </div>

    @if (authError) {
      <tui-notification size="m" class="margin-top-md" appearance="error"
        ><div>
          <label translate>SIGN_IN.COGNITO_ERROR</label>
          <div class="message">{{ authError }}</div>
          <div class="margin-top-sm">
            <a href="mailto:" translate>SIGN_IN.CONTACT_SUPPORT</a>
          </div>
        </div></tui-notification
      >
    }
  </tui-island>
</div>
